/* src/app/components/core/layout/footer/footer.component.css */
.copyright {
  color: #FFFFFF;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5;
  letter-spacing: 0.02em;
}
.footer {
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 4px 10px;
  position: fixed;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  background: #004C4A;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  z-index: 100;
}
.footer-links {
  display: flex;
  align-items: center;
  gap: 16px;
}
.footer-links a {
  color: #B0E5E2;
  text-decoration: underline;
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0;
  border-radius: 0;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
}
.footer-links a::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 12px;
  right: 12px;
  height: 2px;
  background: rgba(255, 255, 255, 0.6);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.footer-links a:hover {
  color: #FFFFFF;
  text-decoration: underline;
}
.footer-links a:hover::before {
  transform: scaleX(1);
}
.footer > div {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 1 auto;
  min-width: 0;
}
.footer-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 auto;
  min-width: 0;
}
.footer-translate {
  min-width: 0;
}
.footer-controls ::ng-deep .goog-te-combo {
  max-width: 180px;
  width: 180px;
}
@media (max-width: 900px) {
  .footer {
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 6px;
    padding: 6px 8px;
  }
  .footer-links {
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .footer-controls {
    gap: 8px;
    justify-content: center;
  }
  .footer-controls ::ng-deep .goog-te-combo {
    max-width: 150px;
    width: 150px;
  }
  .footer-links a,
  .copyright {
    font-size: 0.75rem;
  }
  .copyright {
    flex: 1 1 100%;
    text-align: center;
    border-left: none !important;
    padding-top: 2px;
  }
}
.footer-links {
  flex: 0 1 auto;
  min-width: 0;
}
.copyright {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.footer > div {
  padding: 0 12px;
}
.footer > div + div {
  border-left: 1px solid rgba(255, 255, 255, 0.25);
}
.footer-links,
.footer-links a,
.copyright {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .footer {
    padding: 6px 8px;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 6px;
  }
  .footer > div {
    padding: 0 8px;
  }
  .footer-controls {
    flex: 0 1 auto;
  }
  .footer-links {
    flex-wrap: wrap;
    justify-content: center;
  }
  .footer-controls ::ng-deep .goog-te-combo {
    max-width: 160px;
    width: 160px;
  }
  .copyright {
    flex: 1 1 100%;
    text-align: center;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    border-left: none !important;
    padding-top: 2px;
  }
  .footer-links a,
  .copyright {
    font-size: 0.75rem;
  }
}
@media (max-width: 600px) {
  .footer {
    padding: 4px 6px;
  }
  .footer > div {
    padding: 0 6px;
  }
  .footer-links a,
  .copyright {
    font-size: 0.6rem;
    line-height: 1;
  }
  ::ng-deep .theme-toggle-btn {
    padding: 2px 4px !important;
    font-size: 0.65rem !important;
    height: 20px !important;
    min-height: 20px !important;
  }
  .footer-controls ::ng-deep .font-selector {
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    margin: 0;
  }
  .footer-controls ::ng-deep .font-selector label {
    display: none;
  }
  ::ng-deep .font-selector {
    font-size: 0.65rem;
  }
  ::ng-deep .font-selector select {
    padding: 2px 4px;
    font-size: 0.65rem;
    max-width: 110px;
    height: 24px;
  }
  .footer-controls ::ng-deep select {
    max-width: 160px;
  }
  .footer-controls ::ng-deep .goog-te-gadget {
    height: 24px !important;
    display: inline-flex !important;
    align-items: center !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .footer-controls ::ng-deep .goog-te-combo {
    height: 24px !important;
    line-height: 24px !important;
    min-height: 0 !important;
    max-width: 160px;
    opacity: 1 !important;
    visibility: visible !important;
    display: inline-block !important;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.footer > div {
  animation: fadeInUp 0.6s ease forwards;
}
.footer > div:nth-child(1) {
  animation-delay: 0.1s;
}
.footer > div:nth-child(2) {
  animation-delay: 0.2s;
}
.footer > div:nth-child(3) {
  animation-delay: 0.3s;
}
.footer > div:nth-child(4) {
  animation-delay: 0.4s;
}
body.dark-theme .footer {
  background: #0a1a19;
  border-top-color: rgba(255, 255, 255, 0.05);
}
body.dark-theme .footer-links a {
  color: rgba(255, 255, 255, 0.75);
}
body.dark-theme .footer-links a:hover {
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.08);
}
.theme-toggle-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 8px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
::ng-deep .theme-toggle-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #FFFFFF !important;
  transition: all 0.3s ease !important;
}
::ng-deep .theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}
body.dark-theme ::ng-deep .theme-toggle-btn {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
}
body.dark-theme ::ng-deep .theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}
/*# sourceMappingURL=footer.component-3OSZHKCR.css.map */
